import { SuccessWindowWrapper } from './SuccessWindowStyles'
import Paper from '@mui/material/Paper'

export const SuccessWindow = ({ children }): JSX.Element => {
  return <Paper sx={SuccessWindowWrapper}>{children}</Paper>
}
